module.exports = __webpack_public_path__ + "static/img/icon_location.7162899b.png";